exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "article[data-v-2d6a831a]{display:grid;grid-template-rows:100px 1fr}", "", {"version":3,"sources":["/Users/wala/LocalDev/moviepass-theaters/src/components/Home.vue"],"names":[],"mappings":"AACA,yBACE,aAAc,AACd,4BAA8B,CAC/B","file":"Home.vue","sourcesContent":["\narticle[data-v-2d6a831a] {\n  display: grid;\n  grid-template-rows: 100px 1fr;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-2d6a831a","scoped":true,"hasInlineConfig":false}!./node_modules/less-loader/dist/cjs.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Home.vue
// module id = 31
// module chunks = 0